const translations = {
  en: {
    "Voice Control": "Voice Control",
    "Audio File Upload": "Audio File Upload",
    "Logout": "Logout",
    "Admin Page": "Admin Page",
    "Select Language": "Select Language",
    "Select Gender": "Select Gender",
    "Select Age Category": "Select Age Category",
    "Category": "Category",
    "Voice Control": "Voice Control",
    "Sample Utterances": "Sample Utterances",
    "Select Audio Input Method": "Select Audio Input Method",
    "Upload Audio": "Upload Audio",
    "Record Audio": "Record Audio",
    "Start Audio": "Start",
    "Upload": "Upload",
    "Previews Audio": "Previews Audio",
    "Uploaded Audios": "Uploaded Audios",
    "Language": "Language",
    "Gender & Age": "Gender & Age",
    "Audio Text": "Audio Text",
    "AI Transcribed Text": "AI Transcribed Text",
    "File Name": "File Name",
    "Play": "Play",
    "Stop": "Stop",
    "Download": "Download",
    "OK": "OK",
    "Not OK": "Not OK",
    "No utterances available": "No utterances available",
    "Transcribing": "Transcribing",
    "Choose File": "Choose File",
    "No file chosen": "No file chosen",
    "English (US)": "English (US)",
    "Female": "Female",
    "Male": "Male",
    "Kid": "Kid",
    "Adult": "Adult",
    "Older": "Older",
    "Select Category": "Select Category",
    "Select Voice Control": "Select Voice Control",
    "Login": "Login",
    "Email": "Email",
    "Password": "Password",
    "Success": "Success",
    "Successfully logged in!": "Successfully logged in!",
    "Error": "Error",
    "Login failed": "Login failed",
    "Network error: ": "Network error: ",
    "Something went wrong": "Something went wrong",
    "Translated Text": "Translated Text",
    "Enter the correct text here": "Enter the correct text here",
    "User Input": "User Input",
    "User Input Text": "User Input Text",
    "Transcription Status": "Transcription Status",
    "Filter by Language": "Filter by Language",
    "Filter by Voice Control": "Filter by Voice Control",
    "Get ZIP": "Get ZIP",
    "Select All": "Select All",
    "Upload Date": "Upload Date",
    "All Languages": "All Languages",
    "All Voice Controls": "All Voice Controls",
    "Uploader Email": "Uploader Email",
    "Channel Name": "Channel Name",
    "Enter channel name (e.g., BBC, HBO)": "Enter channel name (e.g., BBC, HBO)",
    "Channel Name Upload": "Channel Name Upload",
    "Search Channels": "Search Channels",
    "Search for a channel...": "Search for a channel...",
    "Upload Channel Names": "Upload Channel Names",
    "Excel Upload": "Excel Upload",
    "Manual Upload": "Manual Upload",
    "Upload Excel File": "Upload Excel File",
    "Download Template": "Download Template",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "Excel file should contain 'languageCode' and 'channelName' columns.",
    "Upload Channels": "Upload Channels",
    "My Channels": "My Channels",
    "All Channels": "All Channels",
    "My Uploaded Channels": "My Uploaded Channels",
    "Language Code": "Language Code",
    "Actions": "Actions",
    "Channels by Language Code": "Channels by Language Code",
    "Channel Count": "Channel Count",
    "Only .xlsx or .xls files are allowed.": "Only .xlsx or .xls files are allowed.",
    "File size should be 5MB or less.": "File size should be 5MB or less.",
    "Please select an Excel file to upload.": "Please select an Excel file to upload.",
    "Please provide a valid uploader email.": "Please provide a valid uploader email.",
    "Channels processed successfully!": "Channels processed successfully!",
    "Inserted Channels": "Inserted Channels",
    "Skipped Duplicates": "Skipped Duplicates",
    "Skipped Channels": "Skipped Channels",
    "Invalid Rows": "Invalid Rows",
    "Language Codes": "Language Codes",
    "Country": "Country",
    "Select or Enter Country": "Select or Enter Country",
    "Select a country...": "Select a country...",
    "Excel file should contain 'appId' and 'appName' columns.": "Excel file should contain 'appId' and 'appName' columns.",
    "App ID": "App ID",
    "Upload App Names.": "Upload App Names.",
    "Upload Apps": "Upload Apps",
    "My Apps": "My Apps",
    "All Apps": "All Apps",
    "App Name": "App Name",
    "Edit": "Edit",
    "Delete": "Delete",
    "Apps by App ID": "Apps by App ID",
    "App Count": "App Count",
    "Enter uploader email": "Enter uploader email",
    "Enter app ID (alphanumeric and 14underscores only)": "Enter app ID (alphanumeric and underscores only)",
    "Enter app name": "Enter app name",
    "My Uploaded Apps": "My Uploaded Apps",
  },
  pt: {
    "Voice Control": "Controle de Voz",
    "Audio File Upload": "Carregar Arquivo de Áudio",
    "Logout": "Sair",
    "Admin Page": "Página de Administração",
    "Select Language": "Selecionar Idioma",
    "Select Gender": "Selecionar Gênero",
    "Select Age Category": "Selecionar Categoria de Idade",
    "Category": "Categoria",
    "Voice Control": "Controle por Voz",
    "Sample Utterances": "Exemplos de Frases",
    "Select Audio Input Method": "Selecionar Método de Entrada de Áudio",
    "Upload Audio": "Carregar Áudio",
    "Record Audio": "Gravar Áudio",
    "Start Audio": "Começar",
    "Upload": "Enviar",
    "Previews Audio": "Pré-visualizar Áudio",
    "Uploaded Audios": "Áudios Carregados",
    "Language": "Idioma",
    "Gender & Age": "Gênero e Idade",
    "Audio Text": "Texto do Áudio",
    "AI Transcribed Text": "Texto Transcrito por IA",
    "File Name": "Nome do Arquivo",
    "Play": "Tocar",
    "Stop": "Parar",
    "Download": "Baixar",
    "OK": "OK",
    "Not OK": "Não OK",
    "No utterances available": "Nenhuma frase disponível",
    "Transcribing": "Transcrevendo",
    "Choose File": "Escolher Arquivo",
    "No file chosen": "Nenhum arquivo escolhido",
    "English (US)": "Inglês (EUA)",
    "Female": "Feminino",
    "Male": "Masculino",
    "Kid": "Criança",
    "Adult": "Adulto",
    "Older": "Idoso",
    "Select Category": "Selecionar Categoria",
    "Select Voice Control": "Selecionar Controle por Voz",
    "Login": "Entrar",
    "Email": "E-mail",
    "Password": "Senha",
    "Success": "Sucesso",
    "Successfully logged in!": "Login realizado com sucesso!",
    "Error": "Erro",
    "Login failed": "Falha no login",
    "Network error: ": "Erro de rede: ",
    "Something went wrong": "Algo deu errado",
    "Translated Text": "Texto Traduzido",
    "Enter the correct text here": "Insira o texto correto aqui",
    "User Input": "Entrada do Usuário",
    "User Input Text": "Texto de Entrada do Usuário",
    "Transcription Status": "Estado da Transcrição",
    "Filter by Language": "Filtrar por Idioma",
    "Filter by Voice Control": "Filtrar por Controle de Voz",
    "Get ZIP": "Obter ZIP",
    "Select All": "Selecionar Tudo",
    "Upload Date": "Data de Carregamento",
    "All Languages": "Todos os Idiomas",
    "All Voice Controls": "Todos os Controles de Voz",
    "Uploader Email": "E-mail do Carregador",
    "Channel Name": "Nome do Canal",
    "Enter channel name (e.g., BBC, HBO)": "Insira o nome do canal (ex.: BBC, HBO)",
    "Channel Name Upload": "Carregamento de Nome de Canal",
    "Search Channels": "Pesquisar Canais",
    "Search for a channel...": "Pesquisar por um canal...",
    "Upload Channel Names": "Carregar Nomes de Canais",
    "Excel Upload": "Carregar Excel",
    "Manual Upload": "Carregamento Manual",
    "Upload Excel File": "Carregar Arquivo Excel",
    "Download Template": "Baixar Modelo",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "O arquivo Excel deve conter as colunas 'languageCode' e 'channelName'.",
    "Upload Channels": "Carregar Canais",
    "My Channels": "Meus Canais",
    "All Channels": "Todos os Canais",
    "My Uploaded Channels": "Meus Canais Carregados",
    "Language Code": "Código de Idioma",
    "Actions": "Ações",
    "Channels by Language Code": "Canais por Código de Idioma",
    "Channel Count": "Contagem de Canais",
    "Only .xlsx or .xls files are allowed.": "Apenas arquivos .xlsx ou .xls são permitidos.",
    "File size should be 5MB or less.": "O tamanho do arquivo deve ser 5MB ou menos.",
    "Please select an Excel file to upload.": "Por favor, selecione um arquivo Excel para carregar.",
    "Please provide a valid uploader email.": "Por favor, forneça um e-mail de carregador válido.",
    "Channels processed successfully!": "Canais processados com sucesso!",
    "Inserted Channels": "Canais Inseridos",
    "Skipped Duplicates": "Canais Duplicados Ignorados",
    "Skipped Channels": "Canais Ignorados",
    "Invalid Rows": "Linhas Inválidas",
    "Language Codes": "Códigos de Idioma",
    "Country": "País",
    "Select or Enter Country": "Selecionar ou Inserir País",
    "Select a country...": "Selecionar um país...",
    "Excel file should contain 'appId' and 'appName' columns.": "O arquivo Excel deve conter as colunas 'appId' e 'appName'.",
    "App ID": "ID do App",
    "Upload App Names.": "Enviar nomes de apps.",
    "Upload Apps": "Enviar apps",
    "My Apps": "Meus apps",
    "All Apps": "Todos os apps",
    "App Name": "Nome do app",
    "Edit": "Editar",
    "Delete": "Excluir",
    "Apps by App ID": "Apps por ID",
    "App Count": "Contagem de apps",
    "Enter uploader email": "Insira o email do remetente",
    "Enter app ID (alphanumeric and 14underscores only)": "Insira o ID do app (alfanumérico e underscores somente)",
    "Enter app name": "Insira o nome do app",
    "My Uploaded Apps": "Meus Apps Enviados",
  },
  es: {
    "Voice Control": "Control de Voz",
    "Audio File Upload": "Cargar Archivo de Audio",
    "Logout": "Cerrar Sesión",
    "Admin Page": "Página de Administración",
    "Select Language": "Seleccionar Idioma",
    "Select Gender": "Seleccionar Género",
    "Select Age Category": "Seleccionar Categoría de Edad",
    "Category": "Categoría",
    "Voice Control": "Control por Voz",
    "Sample Utterances": "Ejemplos de Frases",
    "Select Audio Input Method": "Seleccionar Método de Entrada de Audio",
    "Upload Audio": "Cargar Audio",
    "Record Audio": "Grabar Audio",
    "Start Audio": "Comenzar",
    "Upload": "Subir",
    "Previews Audio": "Previsualizar Audio",
    "Uploaded Audios": "Audios Subidos",
    "Language": "Idioma",
    "Gender & Age": "Género y Edad",
    "Audio Text": "Texto del Audio",
    "AI Transcribed Text": "Texto Transcrito por IA",
    "File Name": "Nombre del Archivo",
    "Play": "Reproducir",
    "Stop": "Detener",
    "Download": "Descargar",
    "OK": "OK",
    "Not OK": "No OK",
    "No utterances available": "No hay frases disponibles",
    "Transcribing": "Transcribiendo",
    "Choose File": "Elegir Archivo",
    "No file chosen": "Ningún archivo seleccionado",
    "English (US)": "Inglés (EE.UU.)",
    "Female": "Femenino",
    "Male": "Masculino",
    "Kid": "Niño",
    "Adult": "Adulto",
    "Older": "Mayor",
    "Select Category": "Seleccionar Categoría",
    "Select Voice Control": "Seleccionar Control por Voz",
    "Login": "Iniciar Sesión",
    "Email": "Correo Electrónico",
    "Password": "Contraseña",
    "Success": "Éxito",
    "Successfully logged in!": "¡Inicio de sesión exitoso!",
    "Error": "Error",
    "Login failed": "Fallo en el inicio de sesión",
    "Network error: ": "Error de red: ",
    "Something went wrong": "Algo salió mal",
    "Translated Text": "Texto Traducido",
    "Enter the correct text here": "Ingrese el texto correcto aquí",
    "User Input": "Entrada del Usuario",
    "User Input Text": "Texto de Entrada del Usuario",
    "Transcription Status": "Estado de la Transcripción",
    "Filter by Language": "Filtrar por Idioma",
    "Filter by Voice Control": "Filtrar por Control de Voz",
    "Get ZIP": "Obtener ZIP",
    "Select All": "Seleccionar Todo",
    "Upload Date": "Fecha de Carga",
    "All Languages": "Todos los Idiomas",
    "All Voice Controls": "Todos los Controles de Voz",
    "Uploader Email": "Correo del Subidor",
    "Channel Name": "Nombre del Canal",
    "Enter channel name (e.g., BBC, HBO)": "Ingrese el nombre del canal (ej., BBC, HBO)",
    "Channel Name Upload": "Carga de Nombre de Canal",
    "Search Channels": "Buscar Canales",
    "Search for a channel...": "Buscar un canal...",
    "Upload Channel Names": "Cargar Nombres de Canales",
    "Excel Upload": "Carga de Excel",
    "Manual Upload": "Carga Manual",
    "Upload Excel File": "Cargar Archivo Excel",
    "Download Template": "Descargar Plantilla",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "El archivo Excel debe contener las columnas 'languageCode' y 'channelName'.",
    "Upload Channels": "Cargar Canales",
    "My Channels": "Mis Canales",
    "All Channels": "Todos los Canales",
    "My Uploaded Channels": "Mis Canales Subidos",
    "Language Code": "Código de Idioma",
    "Actions": "Acciones",
    "Channels by Language Code": "Canales por Código de Idioma",
    "Channel Count": "Conteo de Canales",
    "Only .xlsx or .xls files are allowed.": "Solo se permiten archivos .xlsx o .xls.",
    "File size should be 5MB or less.": "El tamaño del archivo debe ser de 5MB o menos.",
    "Please select an Excel file to upload.": "Por favor, selecciona un archivo Excel para cargar.",
    "Please provide a valid uploader email.": "Por favor, proporciona un correo electrónico de subidor válido.",
    "Channels processed successfully!": "¡Canales procesados con éxito!",
    "Inserted Channels": "Canales Insertados",
    "Skipped Duplicates": "Canales Duplicados Omitidos",
    "Skipped Channels": "Canales Omitidos",
    "Invalid Rows": "Filas Inválidas",
    "Language Codes": "Códigos de Idioma",
    "Country": "País",
    "Select or Enter Country": "Seleccionar o Ingresar País",
    "Select a country...": "Seleccionar un país...",
    "Excel file should contain 'appId' and 'appName' columns.": "El archivo Excel debe contener las columnas 'appId' y 'appName'.",
    "App ID": "ID de la aplicación",
    "Upload App Names.": "Subir nombres de apps.",
    "Upload Apps": "Subir apps",
    "My Apps": "Mis apps",
    "All Apps": "Todas las apps",
    "App Name": "Nombre de la app",
    "Edit": "Editar",
    "Delete": "Eliminar",
    "Apps by App ID": "Apps por ID",
    "App Count": "Cantidad de apps",
    "Enter uploader email": "Ingrese el correo del cargador",
    "Enter app ID (alphanumeric and 14underscores only)": "Ingrese el ID de la app (alfanumérico y guiones bajos solamente)",
    "Enter app name": "Ingrese el nombre de la app",
    "My Uploaded Apps": "Mis Aplicaciones Subidas",
  },
  'es-ar': {
    "Voice Control": "Control de Voz",
    "Audio File Upload": "Cargar Archivo de Audio",
    "Logout": "Cerrar Sesión",
    "Admin Page": "Página de Administración",
    "Select Language": "Seleccionar Idioma",
    "Select Gender": "Seleccionar Género",
    "Select Age Category": "Seleccionar Categoría de Edad",
    "Category": "Categoría",
    "Voice Control": "Control por Voz",
    "Sample Utterances": "Ejemplos de Frases",
    "Select Audio Input Method": "Seleccionar Método de Entrada de Audio",
    "Upload Audio": "Cargar Audio",
    "Record Audio": "Grabar Audio",
    "Start Audio": "Comenzar",
    "Upload": "Subir",
    "Previews Audio": "Previsualizar Audio",
    "Uploaded Audios": "Audios Subidos",
    "Language": "Idioma",
    "Gender & Age": "Género y Edad",
    "Audio Text": "Texto del Audio",
    "AI Transcribed Text": "Texto Transcrito por IA",
    "File Name": "Nombre del Archivo",
    "Play": "Reproducir",
    "Stop": "Detener",
    "Download": "Descargar",
    "OK": "OK",
    "Not OK": "No OK",
    "No utterances available": "No hay frases disponibles",
    "Transcribing": "Transcribiendo",
    "Choose File": "Elegir Archivo",
    "No file chosen": "Ningún archivo seleccionado",
    "English (US)": "Inglés (EE.UU.)",
    "Female": "Femenino",
    "Male": "Masculino",
    "Kid": "Niño",
    "Adult": "Adulto",
    "Older": "Mayor",
    "Select Category": "Seleccionar Categoría",
    "Select Voice Control": "Seleccionar Control por Voz",
    "Login": "Iniciar Sesión",
    "Email": "Correo Electrónico",
    "Password": "Contraseña",
    "Success": "Éxito",
    "Successfully logged in!": "¡Inicio de sesión exitoso!",
    "Error": "Error",
    "Login failed": "Fallo en el inicio de sesión",
    "Network error: ": "Error de red: ",
    "Something went wrong": "Algo salió mal",
    "Translated Text": "Texto Traducido",
    "Enter the correct text here": "Ingrese el texto correcto aquí",
    "User Input": "Entrada del Usuario",
    "User Input Text": "Texto de Entrada del Usuario",
    "Transcription Status": "Estado de la Transcripción",
    "Filter by Language": "Filtrar por Idioma",
    "Filter by Voice Control": "Filtrar por Control de Voz",
    "Get ZIP": "Obtener ZIP",
    "Select All": "Seleccionar Todo",
    "Upload Date": "Fecha de Carga",
    "All Languages": "Todos los Idiomas",
    "All Voice Controls": "Todos los Controles de Voz",
    "Uploader Email": "Correo del Subidor",
    "Channel Name": "Nombre del Canal",
    "Enter channel name (e.g., BBC, HBO)": "Ingrese el nombre del canal (ej., BBC, HBO)",
    "Channel Name Upload": "Carga de Nombre de Canal",
    "Search Channels": "Buscar Canales",
    "Search for a channel...": "Buscar un canal...",
    "Upload Channel Names": "Cargar Nombres de Canales",
    "Excel Upload": "Carga de Excel",
    "Manual Upload": "Carga Manual",
    "Upload Excel File": "Cargar Archivo Excel",
    "Download Template": "Descargar Plantilla",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "El archivo Excel debe contener las columnas 'languageCode' y 'channelName'.",
    "Upload Channels": "Cargar Canales",
    "My Channels": "Mis Canales",
    "All Channels": "Todos los Canales",
    "My Uploaded Channels": "Mis Canales Subidos",
    "Language Code": "Código de Idioma",
    "Actions": "Acciones",
    "Channels by Language Code": "Canales por Código de Idioma",
    "Channel Count": "Conteo de Canales",
    "Only .xlsx or .xls files are allowed.": "Solo se permiten archivos .xlsx o .xls.",
    "File size should be 5MB or less.": "El tamaño del archivo debe ser de 5MB o menos.",
    "Please select an Excel file to upload.": "Por favor, seleccioná un archivo Excel para cargar.",
    "Please provide a valid uploader email.": "Por favor, proporcioná un correo electrónico de subidor válido.",
    "Channels processed successfully!": "¡Canales procesados con éxito!",
    "Inserted Channels": "Canales Insertados",
    "Skipped Duplicates": "Canales Duplicados Omitidos",
    "Skipped Channels": "Canales Omitidos",
    "Invalid Rows": "Filas Inválidas",
    "Language Codes": "Códigos de Idioma",
    "Country": "País",
    "Select or Enter Country": "Seleccionar o Ingresar País",
    "Select a country...": "Seleccionar un país...",
    "Excel file should contain 'appId' and 'appName' columns.": "El archivo de Excel debe contener las columnas 'appId' y 'appName'.",
    "App ID": "ID de la app",
    "Upload App Names.": "Subir nombres de apps.",
    "Upload Apps": "Subir apps",
    "My Apps": "Mis apps",
    "All Apps": "Todas las apps",
    "App Name": "Nombre de la app",
    "Edit": "Editar",
    "Delete": "Eliminar",
    "Apps by App ID": "Apps por ID",
    "App Count": "Cantidad de apps",
    "Enter uploader email": "Ingrese el correo del cargador",
    "Enter app ID (alphanumeric and 14underscores only)": "Ingrese el ID de la app (alfanumérico y guiones bajos solamente)",
    "Enter app name": "Ingrese el nombre de la app",
    "My Uploaded Apps": "Mis Aplicaciones Subidas",
  },
  es_mx: {
    "Voice Control": "Control de Voz",
    "Audio File Upload": "Cargar Archivo de Audio",
    "Logout": "Cerrar Sesión",
    "Admin Page": "Página de Administración",
    "Select Language": "Seleccionar Idioma",
    "Select Gender": "Seleccionar Género",
    "Select Age Category": "Seleccionar Categoría de Edad",
    "Category": "Categoría",
    "Voice Control": "Control por Voz",
    "Sample Utterances": "Ejemplos de Frases",
    "Select Audio Input Method": "Seleccionar Método de Entrada de Audio",
    "Upload Audio": "Cargar Audio",
    "Record Audio": "Grabar Audio",
    "Start Audio": "Comenzar",
    "Upload": "Subir",
    "Previews Audio": "Previsualizar Audio",
    "Uploaded Audios": "Audios Subidos",
    "Language": "Idioma",
    "Gender & Age": "Género y Edad",
    "Audio Text": "Texto del Audio",
    "AI Transcribed Text": "Texto Transcrito por IA",
    "File Name": "Nombre del Archivo",
    "Play": "Reproducir",
    "Stop": "Detener",
    "Download": "Descargar",
    "OK": "OK",
    "Not OK": "No OK",
    "No utterances available": "No hay frases disponibles",
    "Transcribing": "Transcribiendo",
    "Choose File": "Elegir Archivo",
    "No file chosen": "Ningún archivo seleccionado",
    "English (US)": "Inglés (EE.UU.)",
    "Female": "Femenino",
    "Male": "Masculino",
    "Kid": "Niño",
    "Adult": "Adulto",
    "Older": "Mayor",
    "Select Category": "Seleccionar Categoría",
    "Select Voice Control": "Seleccionar Control por Voz",
    "Login": "Iniciar Sesión",
    "Email": "Correo Electrónico",
    "Password": "Contraseña",
    "Success": "Éxito",
    "Successfully logged in!": "¡Inicio de sesión exitoso!",
    "Error": "Error",
    "Login failed": "Fallo en el inicio de sesión",
    "Network error: ": "Error de red: ",
    "Something went wrong": "Algo salió mal",
    "Translated Text": "Texto Traducido",
    "Enter the correct text here": "Ingrese el texto correcto aquí",
    "User Input": "Entrada del Usuario",
    "User Input Text": "Texto de Entrada del Usuario",
    "Transcription Status": "Estado de la Transcripción",
    "Filter by Language": "Filtrar por Idioma",
    "Filter by Voice Control": "Filtrar por Control de Voz",
    "Get ZIP": "Obtener ZIP",
    "Select All": "Seleccionar Todo",
    "Upload Date": "Fecha de Carga",
    "All Languages": "Todos los Idiomas",
    "All Voice Controls": "Todos los Controles de Voz",
    "Uploader Email": "Correo del Subidor",
    "Channel Name": "Nombre del Canal",
    "Enter channel name (e.g., BBC, HBO)": "Ingrese el nombre del canal (ej., BBC, HBO)",
    "Channel Name Upload": "Carga de Nombre de Canal",
    "Search Channels": "Buscar Canales",
    "Search for a channel...": "Buscar un canal...",
    "Upload Channel Names": "Cargar Nombres de Canales",
    "Excel Upload": "Carga de Excel",
    "Manual Upload": "Carga Manual",
    "Upload Excel File": "Cargar Archivo Excel",
    "Download Template": "Descargar Plantilla",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "El archivo Excel debe contener las columnas 'languageCode' y 'channelName'.",
    "Upload Channels": "Cargar Canales",
    "My Channels": "Mis Canales",
    "All Channels": "Todos los Canales",
    "My Uploaded Channels": "Mis Canales Subidos",
    "Language Code": "Código de Idioma",
    "Actions": "Acciones",
    "Channels by Language Code": "Canales por Código de Idioma",
    "Channel Count": "Conteo de Canales",
    "Only .xlsx or .xls files are allowed.": "Solo se permiten archivos .xlsx o .xls.",
    "File size should be 5MB or less.": "El tamaño del archivo debe ser de 5MB o menos.",
    "Please select an Excel file to upload.": "Por favor, selecciona un archivo Excel para cargar.",
    "Please provide a valid uploader email.": "Por favor, proporciona un correo electrónico de subidor válido.",
    "Channels processed successfully!": "¡Canales procesados con éxito!",
    "Inserted Channels": "Canales Insertados",
    "Skipped Duplicates": "Canales Duplicados Omitidos",
    "Skipped Channels": "Canales Omitidos",
    "Invalid Rows": "Filas Inválidas",
    "Language Codes": "Códigos de Idioma",
    "Country": "País",
    "Select or Enter Country": "Seleccionar o Ingresar País",
    "Select a country...": "Seleccionar un país...",
    "Excel file should contain 'appId' and 'appName' columns.": "El archivo Excel debe tener las columnas 'appId' y 'appName'.",
    "App ID": "ID de la app",
    "Upload App Names.": "Subir nombres de apps.",
    "Upload Apps": "Subir apps",
    "My Apps": "Mis apps",
    "All Apps": "Todas las apps",
    "App Name": "Nombre de la app",
    "Edit": "Editar",
    "Delete": "Eliminar",
    "Apps by App ID": "Apps por ID",
    "App Count": "Número de apps",
    "Enter uploader email": "Ingrese el correo del remitente",
    "Enter app ID (alphanumeric and 14underscores only)": "Ingrese el ID de la app (solo alfanumérico y guiones bajos)",
    "Enter app name": "Ingrese el nombre de la app",
    "My Uploaded Apps": "Mis Aplicaciones Cargadas",
  },
  'es-cl': {
    "Voice Control": "Control de Voz",
    "Audio File Upload": "Subir Archivo de Audio",
    "Logout": "Cerrar Sesión",
    "Admin Page": "Página de Administración",
    "Select Language": "Seleccionar Idioma",
    "Select Gender": "Seleccionar Género",
    "Select Age Category": "Seleccionar Categoría de Edad",
    "Category": "Categoría",
    "Voice Control": "Control por Voz",
    "Sample Utterances": "Frases de Ejemplo",
    "Select Audio Input Method": "Seleccionar Método de Entrada de Audio",
    "Upload Audio": "Subir Audio",
    "Record Audio": "Grabar Audio",
    "Start Audio": "Iniciar",
    "Upload": "Subir",
    "Previews Audio": "Previsualizar Audio",
    "Uploaded Audios": "Audios Subidos",
    "Language": "Idioma",
    "Gender & Age": "Género y Edad",
    "Audio Text": "Texto del Audio",
    "AI Transcribed Text": "Texto Transcrito por IA",
    "File Name": "Nombre del Archivo",
    "Play": "Reproducir",
    "Stop": "Detener",
    "Download": "Descargar",
    "OK": "OK",
    "Not OK": "No OK",
    "No utterances available": "No hay frases disponibles",
    "Transcribing": "Transcribiendo",
    "Choose File": "Elegir Archivo",
    "No file chosen": "Ningún archivo seleccionado",
    "English (US)": "Inglés (EE.UU.)",
    "Female": "Femenino",
    "Male": "Masculino",
    "Kid": "Niño",
    "Adult": "Adulto",
    "Older": "Mayor",
    "Select Category": "Seleccionar Categoría",
    "Select Voice Control": "Seleccionar Control por Voz",
    "Login": "Iniciar Sesión",
    "Email": "Correo Electrónico",
    "Password": "Contraseña",
    "Success": "Éxito",
    "Successfully logged in!": "¡Inicio de sesión exitoso!",
    "Error": "Error",
    "Login failed": "Error al iniciar sesión",
    "Network error: ": "Error de red: ",
    "Something went wrong": "Algo salió mal",
    "Translated Text": "Texto Traducido",
    "Enter the correct text here": "Ingresa el texto correcto aquí",
    "User Input": "Entrada del Usuario",
    "User Input Text": "Texto de Entrada del Usuario",
    "Transcription Status": "Estado de la Transcripción",
    "Filter by Language": "Filtrar por Idioma",
    "Filter by Voice Control": "Filtrar por Control de Voz",
    "Get ZIP": "Obtener ZIP",
    "Select All": "Seleccionar Todo",
    "Upload Date": "Fecha de Subida",
    "All Languages": "Todos los Idiomas",
    "All Voice Controls": "Todos los Controles de Voz",
    "Uploader Email": "Correo del Subidor",
    "Channel Name": "Nombre del Canal",
    "Enter channel name (e.g., BBC, HBO)": "Ingresa el nombre del canal (ej., BBC, HBO)",
    "Channel Name Upload": "Subida de Nombre de Canal",
    "Search Channels": "Buscar Canales",
    "Search for a channel...": "Buscar un canal...",
    "Upload Channel Names": "Subir Nombres de Canales",
    "Excel Upload": "Subida de Excel",
    "Manual Upload": "Subida Manual",
    "Upload Excel File": "Subir Archivo Excel",
    "Download Template": "Descargar Plantilla",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "El archivo Excel debe contener las columnas 'languageCode' y 'channelName'.",
    "Upload Channels": "Subir Canales",
    "My Channels": "Mis Canales",
    "All Channels": "Todos los Canales",
    "My Uploaded Channels": "Mis Canales Subidos",
    "Language Code": "Código de Idioma",
    "Actions": "Acciones",
    "Channels by Language Code": "Canales por Código de Idioma",
    "Channel Count": "Conteo de Canales",
    "Only .xlsx or .xls files are allowed.": "Solo se permiten archivos .xlsx o .xls.",
    "File size should be 5MB or less.": "El tamaño del archivo debe ser de 5MB o menos.",
    "Please select an Excel file to upload.": "Por favor, selecciona un archivo Excel para subir.",
    "Please provide a valid uploader email.": "Por favor, proporciona un correo electrónico de subidor válido.",
    "Channels processed successfully!": "¡Canales procesados con éxito!",
    "Inserted Channels": "Canales Insertados",
    "Skipped Duplicates": "Canales Duplicados Omitidos",
    "Skipped Channels": "Canales Omitidos",
    "Invalid Rows": "Filas Inválidas",
    "Language Codes": "Códigos de Idioma",
    "Country": "País",
    "Select or Enter Country": "Seleccionar o Ingresar País",
    "Select a country...": "Seleccionar un país...",
    "Excel file should contain 'appId' and 'appName' columns.": "El archivo Excel debe tener las columnas 'appId' y 'appName'.",
    "App ID": "ID de la app",
    "Upload App Names.": "Subir nombres de apps.",
    "Upload Apps": "Subir apps",
    "My Apps": "Mis apps",
    "All Apps": "Todas las apps",
    "App Name": "Nombre de la app",
    "Edit": "Editar",
    "Delete": "Eliminar",
    "Apps by App ID": "Apps por ID",
    "App Count": "Cantidad de apps",
    "Enter uploader email": "Ingrese el correo del cargador",
    "Enter app ID (alphanumeric and 14underscores only)": "Ingrese el ID de la app (alfanumérico y guiones bajos)",
    "Enter app name": "Ingrese el nombre de la app",
    "My Uploaded Apps": "Mis Aplicaciones Subidas",
  },
  'es-pe': {
    "Voice Control": "Control de Voz",
    "Audio File Upload": "Subir Archivo de Audio",
    "Logout": "Cerrar Sesión",
    "Admin Page": "Página de Administración",
    "Select Language": "Seleccionar Idioma",
    "Select Gender": "Seleccionar Género",
    "Select Age Category": "Seleccionar Categoría de Edad",
    "Category": "Categoría",
    "Voice Control": "Control por Voz",
    "Sample Utterances": "Frases de Muestra",
    "Select Audio Input Method": "Seleccionar Método de Entrada de Audio",
    "Upload Audio": "Subir Audio",
    "Record Audio": "Grabar Audio",
    "Start Audio": "Iniciar",
    "Upload": "Subir",
    "Previews Audio": "Vista Previa de Audio",
    "Uploaded Audios": "Audios Subidos",
    "Language": "Idioma",
    "Gender & Age": "Género y Edad",
    "Audio Text": "Texto del Audio",
    "AI Transcribed Text": "Texto Transcrito por IA",
    "File Name": "Nombre del Archivo",
    "Play": "Reproducir",
    "Stop": "Detener",
    "Download": "Descargar",
    "OK": "OK",
    "Not OK": "No OK",
    "No utterances available": "No hay frases disponibles",
    "Transcribing": "Transcribiendo",
    "Choose File": "Elegir Archivo",
    "No file chosen": "Ningún archivo elegido",
    "English (US)": "Inglés (EE.UU.)",
    "Female": "Femenino",
    "Male": "Masculino",
    "Kid": "Niño",
    "Adult": "Adulto",
    "Older": "Mayor",
    "Select Category": "Seleccionar Categoría",
    "Select Voice Control": "Seleccionar Control por Voz",
    "Login": "Iniciar Sesión",
    "Email": "Correo Electrónico",
    "Password": "Contraseña",
    "Success": "Éxito",
    "Successfully logged in!": "¡Sesión iniciada exitosamente!",
    "Error": "Error",
    "Login failed": "No se pudo iniciar sesión",
    "Network error: ": "Error de red: ",
    "Something went wrong": "Algo salió mal",
    "Translated Text": "Texto Traducido",
    "Enter the correct text here": "Ingresa el texto correcto aquí",
    "User Input": "Entrada del Usuario",
    "User Input Text": "Texto de Entrada del Usuario",
    "Transcription Status": "Estado de la Transcripción",
    "Filter by Language": "Filtrar por Idioma",
    "Filter by Voice Control": "Filtrar por Control de Voz",
    "Get ZIP": "Obtener ZIP",
    "Select All": "Seleccionar Todo",
    "Upload Date": "Fecha de Subida",
    "All Languages": "Todos los Idiomas",
    "All Voice Controls": "Todos los Controles de Voz",
    "Uploader Email": "Correo del Subidor",
    "Channel Name": "Nombre del Canal",
    "Enter channel name (e.g., BBC, HBO)": "Ingresa el nombre del canal (ej., BBC, HBO)",
    "Channel Name Upload": "Subida de Nombre de Canal",
    "Search Channels": "Buscar Canales",
    "Search for a channel...": "Buscar un canal...",
    "Upload Channel Names": "Subir Nombres de Canales",
    "Excel Upload": "Subida de Excel",
    "Manual Upload": "Subida Manual",
    "Upload Excel File": "Subir Archivo Excel",
    "Download Template": "Descargar Plantilla",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "El archivo Excel debe contener las columnas 'languageCode' y 'channelName'.",
    "Upload Channels": "Subir Canales",
    "My Channels": "Mis Canales",
    "All Channels": "Todos los Canales",
    "My Uploaded Channels": "Mis Canales Subidos",
    "Language Code": "Código de Idioma",
    "Actions": "Acciones",
    "Channels by Language Code": "Canales por Código de Idioma",
    "Channel Count": "Conteo de Canales",
    "Only .xlsx or .xls files are allowed.": "Solo se permiten archivos .xlsx o .xls.",
    "File size should be 5MB or less.": "El tamaño del archivo debe ser de 5MB o menos.",
    "Please select an Excel file to upload.": "Por favor, selecciona un archivo Excel para subir.",
    "Please provide a valid uploader email.": "Por favor, proporciona un correo electrónico de subidor válido.",
    "Channels processed successfully!": "¡Canales procesados con éxito!",
    "Inserted Channels": "Canales Insertados",
    "Skipped Duplicates": "Canales Duplicados Omitidos",
    "Skipped Channels": "Canales Omitidos",
    "Invalid Rows": "Filas Inválidas",
    "Language Codes": "Códigos de Idioma",
    "Country": "País",
    "Select or Enter Country": "Seleccionar o Ingresar País",
    "Select a country...": "Seleccionar un país...",
    "Excel file should contain 'appId' and 'appName' columns.": "El archivo Excel debe tener las columnas 'appId' y 'appName'.",
    "App ID": "ID de la app",
    "Upload App Names.": "Subir nombres de apps.",
    "Upload Apps": "Subir apps",
    "My Apps": "Mis apps",
    "All Apps": "Todas las apps",
    "App Name": "Nombre de la app",
    "Edit": "Editar",
    "Delete": "Eliminar",
    "Apps by App ID": "Apps por ID",
    "App Count": "Cantidad de apps",
    "Enter uploader email": "Ingrese el correo del remitente",
    "Enter app ID (alphanumeric and 14underscores only)": "Ingrese el ID de la app (solo alfanumérico y guiones bajos)",
    "Enter app name": "Ingrese el nombre de la app",
    "My Uploaded Apps": "Mis Aplicaciones Subidas",
  },
  fr: {
    "Voice Control": "Contrôle Vocal",
    "Audio File Upload": "Téléchargement de fichier audio",
    "Logout": "Déconnexion",
    "Admin Page": "Page d'administration",
    "Select Language": "Choisir la langue",
    "Select Gender": "Choisir le genre",
    "Select Age Category": "Choisir la tranche d'âge",
    "Category": "Catégorie",
    "Voice Control": "Contrôle Vocal",
    "Sample Utterances": "Exemples d'énoncés",
    "Select Audio Input Method": "Sélectionner la méthode d'entrée audio",
    "Upload Audio": "Importer l'audio",
    "Record Audio": "Enregistrer l'audio",
    "Start Audio": "Démarrer",
    "Upload": "Téléverser",
    "Previews Audio": "Prévisualiser l'audio",
    "Uploaded Audios": "Audios téléchargés",
    "Language": "Langue",
    "Gender & Age": "Genre et âge",
    "Audio Text": "Texte audio",
    "AI Transcribed Text": "Texte transcrit par IA",
    "File Name": "Nom de fichier",
    "Play": "Lire",
    "Stop": "Arrêter",
    "Download": "Télécharger",
    "OK": "OK",
    "Not OK": "Non OK",
    "No utterances available": "Aucun énoncé disponible",
    "Transcribing": "Transcription en cours",
    "Choose File": "Choisir le fichier",
    "No file chosen": "Aucun fichier sélectionné",
    "English (US)": "Anglais (États-Unis)",
    "Female": "Femme",
    "Male": "Homme",
    "Kid": "Enfant",
    "Adult": "Adulte",
    "Older": "Ainé",
    "Select Category": "Choisir la catégorie",
    "Select Voice Control": "Choisir le contrôle vocal",
    "Login": "Connexion",
    "Email": "E-mail",
    "Password": "Mot de passe",
    "Success": "Succès",
    "Successfully logged in!": "Connexion réussie!",
    "Error": "Erreur",
    "Login failed": "Échec de la connexion",
    "Network error: ": "Erreur réseau: ",
    "Something went wrong": "Une erreur s'est produite",
    "Translated Text": "Texte traduit",
    "Enter the correct text here": "Entrez le texte correct ici",
    "User Input": "Entrée utilisateur",
    "User Input Text": "Texte d'entrée utilisateur",
    "Transcription Status": "État de la transcription",
    "Filter by Language": "Filtrer par langue",
    "Filter by Voice Control": "Filtrer par contrôle vocal",
    "Get ZIP": "Obtenir ZIP",
    "Select All": "Tout sélectionner",
    "Upload Date": "Date de téléversement",
    "All Languages": "Toutes les langues",
    "All Voice Controls": "Tous les contrôles vocaux",
    "Uploader Email": "E-mail de l'uploader",
    "Channel Name": "Nom de la chaîne",
    "Enter channel name (e.g., BBC, HBO)": "Entrez le nom de la chaîne (ex. : BBC, HBO)",
    "Channel Name Upload": "Téléchargement de nom de chaîne",
    "Search Channels": "Rechercher des chaînes",
    "Search for a channel...": "Rechercher une chaîne...",
    "Upload Channel Names": "Télécharger des noms de chaînes",
    "Excel Upload": "Téléchargement Excel",
    "Manual Upload": "Téléchargement manuel",
    "Upload Excel File": "Télécharger fichier Excel",
    "Download Template": "Télécharger le modèle",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "Le fichier Excel doit contenir les colonnes 'languageCode' et 'channelName'.",
    "Upload Channels": "Télécharger des chaînes",
    "My Channels": "Mes chaînes",
    "All Channels": "Toutes les chaînes",
    "My Uploaded Channels": "Mes chaînes téléchargées",
    "Language Code": "Code de langue",
    "Actions": "Actions",
    "Channels by Language Code": "Chaînes par code de langue",
    "Channel Count": "Nombre de chaînes",
    "Only .xlsx or .xls files are allowed.": "Seuls les fichiers .xlsx ou .xls sont autorisés.",
    "File size should be 5MB or less.": "La taille du fichier doit être de 5 Mo ou moins.",
    "Please select an Excel file to upload.": "Veuillez sélectionner un fichier Excel à télécharger.",
    "Please provide a valid uploader email.": "Veuillez fournir un e-mail d'uploader valide.",
    "Channels processed successfully!": "Chaînes traitées avec succès !",
    "Inserted Channels": "Chaînes insérées",
    "Skipped Duplicates": "Chaînes dupliquées ignorées",
    "Skipped Channels": "Chaînes ignorées",
    "Invalid Rows": "Lignes invalides",
    "Language Codes": "Codes de langue",
    "Country": "Pays",
    "Select or Enter Country": "Sélectionner ou Entrer le Pays",
    "Select a country...": "Sélectionner un pays...",
    "Excel file should contain 'appId' and 'appName' columns.": "Le fichier Excel doit contenir les colonnes 'appId' et 'appName'.",
    "App ID": "ID de l'app",
    "Upload App Names.": "Importer les noms d'apps.",
    "Upload Apps": "Importer des apps",
    "My Apps": "Mes apps",
    "All Apps": "Toutes les apps",
    "App Name": "Nom de l'app",
    "Edit": "Modifier",
    "Delete": "Supprimer",
    "Apps by App ID": "Apps par ID",
    "App Count": "Nombre d'apps",
    "Enter uploader email": "Entrez l'email de l'importateur",
    "Enter app ID (alphanumeric and 14underscores only)": "Entrez l'ID de l'app (alphanumérique et underscores seulement)",
    "Enter app name": "Entrez le nom de l'app",
    "My Uploaded Apps": "Mes applications téléversées",
  },
  de: {
    "Voice Control": "Sprachsteuerung",
    "Audio File Upload": "Audio-Datei hochladen",
    "Logout": "Abmelden",
    "Admin Page": "Admin-Seite",
    "Select Language": "Sprache wählen",
    "Select Gender": "Geschlecht auswählen",
    "Select Age Category": "Alterskategorie wählen",
    "Category": "Kategorie",
    "Voice Control": "Sprachsteuerung",
    "Sample Utterances": "Beispielsätze",
    "Select Audio Input Method": "Audio-Eingabemethode wählen",
    "Upload Audio": "Audio hochladen",
    "Record Audio": "Audio aufnehmen",
    "Start Audio": "Start",
    "Upload": "Hochladen",
    "Previews Audio": "Audio-Vorschau",
    "Uploaded Audios": "Hochgeladene Audios",
    "Language": "Sprache",
    "Gender & Age": "Geschlecht & Alter",
    "Audio Text": "Audio-Text",
    "AI Transcribed Text": "KI-transkribierter Text",
    "File Name": "Dateiname",
    "Play": "Abspielen",
    "Stop": "Stopp",
    "Download": "Herunterladen",
    "OK": "OK",
    "Not OK": "Nicht OK",
    "No utterances available": "Keine Beispielsätze verfügbar",
    "Transcribing": "Transkription läuft",
    "Choose File": "Datei auswählen",
    "No file chosen": "Keine Datei ausgewählt",
    "English (US)": "Englisch (USA)",
    "Female": "Weiblich",
    "Male": "Männlich",
    "Kid": "Kind",
    "Adult": "Erwachsener",
    "Older": "Älter",
    "Select Category": "Kategorie auswählen",
    "Select Voice Control": "Sprachsteuerung auswählen",
    "Login": "Anmelden",
    "Email": "E-Mail",
    "Password": "Passwort",
    "Success": "Erfolg",
    "Successfully logged in!": "Erfolgreich angemeldet!",
    "Error": "Fehler",
    "Login failed": "Anmeldung fehlgeschlagen",
    "Network error: ": "Netzwerkfehler: ",
    "Something went wrong": "Etwas ist schiefgelaufen",
    "Translated Text": "Übersetzter Text",
    "Enter the correct text here": "Geben Sie hier den korrekten Text ein",
    "User Input": "Benutzereingabe",
    "User Input Text": "Benutzereingabetext",
    "Transcription Status": "Transkriptionsstatus",
    "Filter by Language": "Nach Sprache filtern",
    "Filter by Voice Control": "Nach Sprachsteuerung filtern",
    "Get ZIP": "ZIP herunterladen",
    "Select All": "Alle auswählen",
    "Upload Date": "Hochladedatum",
    "All Languages": "Alle Sprachen",
    "All Voice Controls": "Alle Sprachsteuerungen",
    "Uploader Email": "E-Mail des Hochladers",
    "Channel Name": "Kanalname",
    "Enter channel name (e.g., BBC, HBO)": "Geben Sie den Kanalnamen ein (z. B. BBC, HBO)",
    "Channel Name Upload": "Kanalnamen hochladen",
    "Search Channels": "Kanäle suchen",
    "Search for a channel...": "Nach einem Kanal suchen...",
    "Upload Channel Names": "Kanalnamen hochladen",
    "Excel Upload": "Excel hochladen",
    "Manual Upload": "Manuelles Hochladen",
    "Upload Excel File": "Excel-Datei hochladen",
    "Download Template": "Vorlage herunterladen",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "Die Excel-Datei muss die Spalten 'languageCode' und 'channelName' enthalten.",
    "Upload Channels": "Kanäle hochladen",
    "My Channels": "Meine Kanäle",
    "All Channels": "Alle Kanäle",
    "My Uploaded Channels": "Meine hochgeladenen Kanäle",
    "Language Code": "Sprachcode",
    "Actions": "Aktionen",
    "Channels by Language Code": "Kanäle nach Sprachcode",
    "Channel Count": "Anzahl der Kanäle",
    "Only .xlsx or .xls files are allowed.": "Nur .xlsx- oder .xls-Dateien sind erlaubt.",
    "File size should be 5MB or less.": "Die Dateigröße darf maximal 5 MB betragen.",
    "Please select an Excel file to upload.": "Bitte wählen Sie eine Excel-Datei zum Hochladen aus.",
    "Please provide a valid uploader email.": "Bitte geben Sie eine gültige E-Mail-Adresse des Hochladers an.",
    "Channels processed successfully!": "Kanäle erfolgreich verarbeitet!",
    "Inserted Channels": "Eingefügte Kanäle",
    "Skipped Duplicates": "Übersprungene Duplikate",
    "Skipped Channels": "Übersprungene Kanäle",
    "Invalid Rows": "Ungültige Zeilen",
    "Language Codes": "Sprachcodes",
    "Country": "Land",
    "Select or Enter Country": "Land auswählen oder eingeben",
    "Select a country...": "Ein Land auswählen...",
    "Excel file should contain 'appId' and 'appName' columns.": "Die Excel-Datei muss die Spalten 'appId' und 'appName' enthalten.",
    "App ID": "App-ID",
    "Upload App Names.": "App-Namen hochladen.",
    "Upload Apps": "Apps hochladen",
    "My Apps": "Meine Apps",
    "All Apps": "Alle Apps",
    "App Name": "App-Name",
    "Edit": "Bearbeiten",
    "Delete": "Löschen",
    "Apps by App ID": "Apps nach App-ID",
    "App Count": "Anzahl der Apps",
    "Enter uploader email": "Geben Sie die E-Mail des Uploaders ein",
    "Enter app ID (alphanumeric and 14underscores only)": "Geben Sie die App-ID ein (nur alphanumerisch und Unterstriche)",
    "Enter app name": "Geben Sie den App-Namen ein",
    "My Uploaded Apps": "Meine hochgeladenen Apps",
  },
  it: {
    "Voice Control": "Controllo Vocale",
    "Audio File Upload": "Caricamento file audio",
    "Logout": "Disconnetti",
    "Admin Page": "Pagina amministratore",
    "Select Language": "Seleziona lingua",
    "Select Gender": "Seleziona genere",
    "Select Age Category": "Seleziona fascia d'età",
    "Category": "Categoria",
    "Voice Control": "Controllo Vocale",
    "Sample Utterances": "Frasi di esempio",
    "Select Audio Input Method": "Seleziona metodo di input audio",
    "Upload Audio": "Carica audio",
    "Record Audio": "Registra audio",
    "Start Audio": "Avvia",
    "Upload": "Carica",
    "Previews Audio": "Anteprima audio",
    "Uploaded Audios": "Audio caricati",
    "Language": "Lingua",
    "Gender & Age": "Genere e età",
    "Audio Text": "Testo audio",
    "AI Transcribed Text": "Testo trascritto da IA",
    "File Name": "Nome file",
    "Play": "Riproduci",
    "Stop": "Interrompi",
    "Download": "Scarica",
    "OK": "OK",
    "Not OK": "Non OK",
    "No utterances available": "Nessuna frase disponibile",
    "Transcribing": "Trascrizione in corso",
    "Choose File": "Scegli file",
    "No file chosen": "Nessun file selezionato",
    "English (US)": "Inglese (USA)",
    "Female": "Femmina",
    "Male": "Maschio",
    "Kid": "Bambino",
    "Adult": "Adulto",
    "Older": "Anziano",
    "Select Category": "Seleziona categoria",
    "Select Voice Control": "Seleziona controllo vocale",
    "Login": "Accesso",
    "Email": "Email",
    "Password": "Password",
    "Success": "Successo",
    "Successfully logged in!": "Accesso riuscito!",
    "Error": "Errore",
    "Login failed": "Accesso non riuscito",
    "Network error: ": "Errore di rete: ",
    "Something went wrong": "Qualcosa è andato storto",
    "Translated Text": "Testo tradotto",
    "Enter the correct text here": "Inserisci qui il testo corretto",
    "User Input": "Input utente",
    "User Input Text": "Testo input utente",
    "Transcription Status": "Stato della trascrizione",
    "Filter by Language": "Filtra per lingua",
    "Filter by Voice Control": "Filtra per controllo vocale",
    "Get ZIP": "Ottieni ZIP",
    "Select All": "Seleziona tutto",
    "Upload Date": "Data di caricamento",
    "All Languages": "Tutte le lingue",
    "All Voice Controls": "Tutti i controlli vocali",
    "Uploader Email": "Email del caricatore",
    "Channel Name": "Nome del canale",
    "Enter channel name (e.g., BBC, HBO)": "Inserisci il nome del canale (es. BBC, HBO)",
    "Channel Name Upload": "Caricamento nome canale",
    "Search Channels": "Cerca canali",
    "Search for a channel...": "Cerca un canale...",
    "Upload Channel Names": "Carica nomi dei canali",
    "Excel Upload": "Caricamento Excel",
    "Manual Upload": "Caricamento manuale",
    "Upload Excel File": "Carica file Excel",
    "Download Template": "Scarica modello",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "Il file Excel deve contenere le colonne 'languageCode' e 'channelName'.",
    "Upload Channels": "Carica canali",
    "My Channels": "I miei canali",
    "All Channels": "Tutti i canali",
    "My Uploaded Channels": "I miei canali caricati",
    "Language Code": "Codice lingua",
    "Actions": "Azioni",
    "Channels by Language Code": "Canali per codice lingua",
    "Channel Count": "Conteggio canali",
    "Only .xlsx or .xls files are allowed.": "Sono consentiti solo file .xlsx o .xls.",
    "File size should be 5MB or less.": "La dimensione del file deve essere di 5 MB o meno.",
    "Please select an Excel file to upload.": "Seleziona un file Excel da caricare.",
    "Please provide a valid uploader email.": "Fornisci un'email valida per il caricatore.",
    "Channels processed successfully!": "Canali elaborati con successo!",
    "Inserted Channels": "Canali inseriti",
    "Skipped Duplicates": "Canali duplicati saltati",
    "Skipped Channels": "Canali saltati",
    "Invalid Rows": "Righe non valide",
    "Language Codes": "Codici lingua",
    "Country": "Paese",
    "Select or Enter Country": "Seleziona o Inserisci Paese",
    "Select a country...": "Seleziona un paese...",
    "Excel file should contain 'appId' and 'appName' columns.": "Il file Excel deve contenere le colonne 'appId' e 'appName'.",
    "App ID": "ID dell'app",
    "Upload App Names.": "Carica nomi delle app.",
    "Upload Apps": "Carica app",
    "My Apps": "Le mie app",
    "All Apps": "Tutte le app",
    "App Name": "Nome dell'app",
    "Edit": "Modifica",
    "Delete": "Elimina",
    "Apps by App ID": "App per ID",
    "App Count": "Conteggio app",
    "Enter uploader email": "Inserisci email del caricatore",
    "Enter app ID (alphanumeric and 14underscores only)": "Inserisci ID app (alfanumerico e underscore)",
    "Enter app name": "Inserisci nome dell'app",
    "My Uploaded Apps": "Le mie app caricate",
  },
  'zh-TW': {
    "Voice Control": "語音控制",
    "Audio File Upload": "上傳音頻文件",
    "Logout": "登出",
    "Admin Page": "管理頁面",
    "Select Language": "選擇語言",
    "Select Gender": "選擇性別",
    "Select Age Category": "選擇年齡類別",
    "Category": "類別",
    "Voice Control": "語音控制",
    "Sample Utterances": "範例語句",
    "Select Audio Input Method": "選擇音頻輸入方式",
    "Upload Audio": "上傳音頻",
    "Record Audio": "錄製音頻",
    "Start Audio": "開始",
    "Upload": "上傳",
    "Previews Audio": "音頻預覽",
    "Uploaded Audios": "已上傳的音頻",
    "Language": "語言",
    "Gender & Age": "性別與年齡",
    "Audio Text": "音頻文本",
    "AI Transcribed Text": "AI轉錄文本",
    "File Name": "文件名",
    "Play": "播放",
    "Stop": "停止",
    "Download": "下載",
    "OK": "確定",
    "Not OK": "不確定",
    "No utterances available": "無可用語句",
    "Transcribing": "正在轉錄",
    "Choose File": "選擇文件",
    "No file chosen": "未選擇文件",
    "English (US)": "英語（美國）",
    "Female": "女性",
    "Male": "男性",
    "Kid": "兒童",
    "Adult": "成人",
    "Older": "老年",
    "Select Category": "選擇類別",
    "Select Voice Control": "選擇語音控制",
    "Login": "登入",
    "Email": "電子郵件",
    "Password": "密碼",
    "Success": "成功",
    "Successfully logged in!": "成功登入！",
    "Error": "錯誤",
    "Login failed": "登入失敗",
    "Network error: ": "網絡錯誤：",
    "Something went wrong": "發生錯誤",
    "Translated Text": "翻譯文本",
    "Enter the correct text here": "在此輸入正確文本",
    "User Input": "用戶輸入",
    "User Input Text": "用戶輸入文本",
    "Transcription Status": "轉錄狀態",
    "Filter by Language": "按語言篩選",
    "Filter by Voice Control": "按語音控制篩選",
    "Get ZIP": "獲取ZIP",
    "Select All": "全選",
    "Upload Date": "上傳日期",
    "All Languages": "所有語言",
    "All Voice Controls": "所有語音控制",
    "Uploader Email": "上傳者電子郵件",
    "Channel Name": "頻道名稱",
    "Enter channel name (e.g., BBC, HBO)": "輸入頻道名稱（例如：BBC、HBO）",
    "Channel Name Upload": "頻道名稱上傳",
    "Search Channels": "搜尋頻道",
    "Search for a channel...": "搜尋一個頻道...",
    "Upload Channel Names": "上傳頻道名稱",
    "Excel Upload": "Excel上傳",
    "Manual Upload": "手動上傳",
    "Upload Excel File": "上傳Excel文件",
    "Download Template": "下載模板",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "Excel文件需包含 'languageCode' 和 'channelName' 欄位。",
    "Upload Channels": "上傳頻道",
    "My Channels": "我的頻道",
    "All Channels": "所有頻道",
    "My Uploaded Channels": "我上傳的頻道",
    "Language Code": "語言代碼",
    "Actions": "操作",
    "Channels by Language Code": "按語言代碼分類的頻道",
    "Channel Count": "頻道數量",
    "Only .xlsx or .xls files are allowed.": "僅允許 .xlsx 或 .xls 文件。",
    "File size should be 5MB or less.": "文件大小需為5MB或以下。",
    "Please select an Excel file to upload.": "請選擇要上傳的Excel文件。",
    "Please provide a valid uploader email.": "請提供有效的上傳者電子郵件。",
    "Channels processed successfully!": "頻道處理成功！",
    "Inserted Channels": "插入的頻道",
    "Skipped Duplicates": "跳過的重複頻道",
    "Skipped Channels": "跳過的頻道",
    "Invalid Rows": "無效行",
    "Language Codes": "語言代碼",
    "Country": "國家",
    "Select or Enter Country": "選擇或輸入國家",
    "Select a country...": "選擇一個國家...",
    "Excel file should contain 'appId' and 'appName' columns.": "Excel 檔案應包含「appId」和「appName」兩欄。",
    "App ID": "應用程式 ID",
    "Upload App Names.": "上傳應用程式名稱。",
    "Upload Apps": "上傳應用程式",
    "My Apps": "我的應用程式",
    "All Apps": "所有應用程式",
    "App Name": "應用程式名稱",
    "Edit": "編輯",
    "Delete": "刪除",
    "Apps by App ID": "依 App ID 顯示應用程式",
    "App Count": "應用程式數量",
    "Enter uploader email": "輸入上傳者電子郵件",
    "Enter app ID (alphanumeric and 14underscores only)": "輸入 App ID(僅限字母數字與底線）",
    "Enter app name": "輸入應用程式名稱",
    "My Uploaded Apps": "我上傳的應用程式",
  },
  'zh-CN': {
    "Voice Control": "语音控制",
    "Audio File Upload": "上传音频文件",
    "Logout": "退出",
    "Admin Page": "管理页面",
    "Select Language": "选择语言",
    "Select Gender": "选择性别",
    "Select Age Category": "选择年龄类别",
    "Category": "类别",
    "Voice Control": "语音控制",
    "Sample Utterances": "示例语句",
    "Select Audio Input Method": "选择音频输入方式",
    "Upload Audio": "上传音频",
    "Record Audio": "录制音频",
    "Start Audio": "开始",
    "Upload": "上传",
    "Previews Audio": "音频预览",
    "Uploaded Audios": "已上传的音频",
    "Language": "语言",
    "Gender & Age": "性别与年龄",
    "Audio Text": "音频文本",
    "AI Transcribed Text": "AI转录文本",
    "File Name": "文件名",
    "Play": "播放",
    "Stop": "停止",
    "Download": "下载",
    "OK": "确定",
    "Not OK": "不正确",
    "No utterances available": "无可用语句",
    "Transcribing": "正在转录",
    "Choose File": "选择文件",
    "No file chosen": "未选择文件",
    "English (US)": "英语（美国）",
    "Female": "女性",
    "Male": "男性",
    "Kid": "儿童",
    "Adult": "成人",
    "Older": "老年",
    "Select Category": "选择类别",
    "Select Voice Control": "选择语音控制",
    "Login": "登录",
    "Email": "电子邮件",
    "Password": "密码",
    "Success": "成功",
    "Successfully logged in!": "登录成功！",
    "Error": "错误",
    "Login failed": "登录失败",
    "Network error: ": "网络错误：",
    "Something went wrong": "出现错误",
    "Translated Text": "翻译文本",
    "Enter the correct text here": "在此输入正确文本",
    "User Input": "用户输入",
    "User Input Text": "用户输入文本",
    "Transcription Status": "转录状态",
    "Filter by Language": "按语言筛选",
    "Filter by Voice Control": "按语音控制筛选",
    "Get ZIP": "获取ZIP",
    "Select All": "全选",
    "Upload Date": "上传日期",
    "All Languages": "所有语言",
    "All Voice Controls": "所有语音控制",
    "Uploader Email": "上传者电子邮件",
    "Channel Name": "频道名称",
    "Enter channel name (e.g., BBC, HBO)": "输入频道名称（例如：BBC、HBO）",
    "Channel Name Upload": "频道名称上传",
    "Search Channels": "搜索频道",
    "Search for a channel...": "搜索一个频道...",
    "Upload Channel Names": "上传频道名称",
    "Excel Upload": "Excel上传",
    "Manual Upload": "手动上传",
    "Upload Excel File": "上传Excel文件",
    "Download Template": "下载模板",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "Excel文件需包含 'languageCode' 和 'channelName' 列。",
    "Upload Channels": "上传频道",
    "My Channels": "我的频道",
    "All Channels": "所有频道",
    "My Uploaded Channels": "我上传的频道",
    "Language Code": "语言代码",
    "Actions": "操作",
    "Channels by Language Code": "按语言代码分类的频道",
    "Channel Count": "频道数量",
    "Only .xlsx or .xls files are allowed.": "仅允许 .xlsx 或 .xls 文件。",
    "File size should be 5MB or less.": "文件大小需为5MB或以下。",
    "Please select an Excel file to upload.": "请选择要上传的Excel文件。",
    "Please provide a valid uploader email.": "请提供有效的上传者电子邮件。",
    "Channels processed successfully!": "频道处理成功！",
    "Inserted Channels": "插入的频道",
    "Skipped Duplicates": "跳过的重复频道",
    "Skipped Channels": "跳过的频道",
    "Invalid Rows": "无效行",
    "Language Codes": "语言代码",
    "Country": "国家",
    "Select or Enter Country": "选择或输入国家",
    "Select a country...": "选择一个国家...",
    "Excel file should contain 'appId' and 'appName' columns.": "Excel 文件应包含“appId”和“appName”列。",
    "App ID": "应用 ID",
    "Upload App Names.": "上传应用名称。",
    "Upload Apps": "上传应用",
    "My Apps": "我的应用",
    "All Apps": "所有应用",
    "App Name": "应用名称",
    "Edit": "编辑",
    "Delete": "删除",
    "Apps by App ID": "按应用 ID 查看应用",
    "App Count": "应用数量",
    "Enter uploader email": "输入上传者邮箱",
    "Enter app ID (alphanumeric and 14underscores only)": "输入应用 ID(仅限字母数字和下划线）",
    "Enter app name": "输入应用名称",
    "My Uploaded Apps": "我上传的应用",
  },
  'zh-SG': {
    "Voice Control": "语音控制",
    "Audio File Upload": "上传音频文件",
    "Logout": "登出",
    "Admin Page": "管理页面",
    "Select Language": "选择语言",
    "Select Gender": "选择性别",
    "Select Age Category": "选择年龄类别",
    "Category": "类别",
    "Voice Control": "语音控制",
    "Sample Utterances": "示例语句",
    "Select Audio Input Method": "选择音频输入方式",
    "Upload Audio": "上传音频",
    "Record Audio": "录制音频",
    "Start Audio": "开始",
    "Upload": "上传",
    "Previews Audio": "音频预览",
    "Uploaded Audios": "已上传的音频",
    "Language": "语言",
    "Gender & Age": "性别与年龄",
    "Audio Text": "音频文本",
    "AI Transcribed Text": "AI转录文本",
    "File Name": "文件名",
    "Play": "播放",
    "Stop": "停止",
    "Download": "下载",
    "OK": "确定",
    "Not OK": "不正确",
    "No utterances available": "无可用语句",
    "Transcribing": "正在转录",
    "Choose File": "选择文件",
    "No file chosen": "未选择文件",
    "English (US)": "英语（美国）",
    "Female": "女性",
    "Male": "男性",
    "Kid": "儿童",
    "Adult": "成人",
    "Older": "老年",
    "Select Category": "选择类别",
    "Select Voice Control": "选择语音控制",
    "Login": "登录",
    "Email": "电子邮件",
    "Password": "密码",
    "Success": "成功",
    "Successfully logged in!": "登录成功！",
    "Error": "错误",
    "Login failed": "登录失败",
    "Network error: ": "网络错误：",
    "Something went wrong": "出现错误",
    "Translated Text": "翻译文本",
    "Enter the correct text here": "在此输入正确文本",
    "User Input": "用户输入",
    "User Input Text": "用户输入文本",
    "Transcription Status": "转录状态",
    "Filter by Language": "按语言筛选",
    "Filter by Voice Control": "按语音控制筛选",
    "Get ZIP": "获取ZIP",
    "Select All": "全选",
    "Upload Date": "上传日期",
    "All Languages": "所有语言",
    "All Voice Controls": "所有语音控制",
    "Uploader Email": "上传者电子邮件",
    "Channel Name": "频道名称",
    "Enter channel name (e.g., BBC, HBO)": "输入频道名称（例如：BBC、HBO）",
    "Channel Name Upload": "频道名称上传",
    "Search Channels": "搜索频道",
    "Search for a channel...": "搜索一个频道...",
    "Upload Channel Names": "上传频道名称",
    "Excel Upload": "Excel上传",
    "Manual Upload": "手动上传",
    "Upload Excel File": "上传Excel文件",
    "Download Template": "下载模板",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "Excel文件需包含 'languageCode' 和 'channelName' 列。",
    "Upload Channels": "上传频道",
    "My Channels": "我的频道",
    "All Channels": "所有频道",
    "My Uploaded Channels": "我上传的频道",
    "Language Code": "语言代码",
    "Actions": "操作",
    "Channels by Language Code": "按语言代码分类的频道",
    "Channel Count": "频道数量",
    "Only .xlsx or .xls files are allowed.": "仅允许 .xlsx 或 .xls 文件。",
    "File size should be 5MB or less.": "文件大小需为5MB或以下。",
    "Please select an Excel file to upload.": "请选择要上传的Excel文件。",
    "Please provide a valid uploader email.": "请提供有效的上传者电子邮件。",
    "Channels processed successfully!": "频道处理成功！",
    "Inserted Channels": "插入的频道",
    "Skipped Duplicates": "跳过的重复频道",
    "Skipped Channels": "跳过的频道",
    "Invalid Rows": "无效行",
    "Language Codes": "语言代码",
    "Country": "国家",
    "Select or Enter Country": "选择或输入国家",
    "Select a country...": "选择一个国家...",
    "Excel file should contain 'appId' and 'appName' columns.": "Excel 文件应包含“appId”和“appName”列。",
    "App ID": "应用程序 ID",
    "Upload App Names.": "上传应用程序名称。",
    "Upload Apps": "上传应用程序",
    "My Apps": "我的应用程序",
    "All Apps": "所有应用程序",
    "App Name": "应用程序名称",
    "Edit": "编辑",
    "Delete": "删除",
    "Apps by App ID": "按应用程序 ID 查看应用程序",
    "App Count": "应用程序数量",
    "Enter uploader email": "输入上传者邮箱",
    "Enter app ID (alphanumeric and 14underscores only)": "输入应用 ID (仅限字母数字和下划线）",
    "Enter app name": "输入应用程序名称",
    "My Uploaded Apps": "我上传的应用程序",
  },
  'nl-BE': {
    "Voice Control": "Spraakbesturing",
    "Audio File Upload": "Audiobestand uploaden",
    "Logout": "Uitloggen",
    "Admin Page": "Beheerpagina",
    "Select Language": "Taal selecteren",
    "Select Gender": "Geslacht selecteren",
    "Select Age Category": "Leeftijdscategorie selecteren",
    "Category": "Categorie",
    "Voice Control": "Spraakbesturing",
    "Sample Utterances": "Voorbeeldzinnen",
    "Select Audio Input Method": "Audiobron selecteren",
    "Upload Audio": "Audio uploaden",
    "Record Audio": "Audio opnemen",
    "Start Audio": "Starten",
    "Upload": "Uploaden",
    "Previews Audio": "Audiovoorbeeld",
    "Uploaded Audios": "Geüploade audio's",
    "Language": "Taal",
    "Gender & Age": "Geslacht en leeftijd",
    "Audio Text": "Audiotekst",
    "AI Transcribed Text": "Door AI getranscribeerde tekst",
    "File Name": "Bestandsnaam",
    "Play": "Afspelen",
    "Stop": "Stoppen",
    "Download": "Downloaden",
    "OK": "OK",
    "Not OK": "Niet OK",
    "No utterances available": "Geen zinnen beschikbaar",
    "Transcribing": "Bezig met transcriberen",
    "Choose File": "Bestand kiezen",
    "No file chosen": "Geen bestand gekozen",
    "English (US)": "Engels (VS)",
    "Female": "Vrouw",
    "Male": "Man",
    "Kid": "Kind",
    "Adult": "Volwassene",
    "Older": "Oudere",
    "Select Category": "Categorie selecteren",
    "Select Voice Control": "Spraakbesturing selecteren",
    "Login": "Inloggen",
    "Email": "E-mail",
    "Password": "Wachtwoord",
    "Success": "Succes",
    "Successfully logged in!": "Succesvol ingelogd!",
    "Error": "Fout",
    "Login failed": "Inloggen mislukt",
    "Network error: ": "Netwerkfout: ",
    "Something went wrong": "Er ging iets mis",
    "Translated Text": "Vertaalde tekst",
    "Enter the correct text here": "Voer hier de correcte tekst in",
    "User Input": "Gebruikersinvoer",
    "User Input Text": "Gebruikersinvoertekst",
    "Transcription Status": "Transcriptiestatus",
    "Filter by Language": "Filteren op taal",
    "Filter by Voice Control": "Filteren op spraakbesturing",
    "Get ZIP": "ZIP downloaden",
    "Select All": "Alles selecteren",
    "Upload Date": "Upload datum",
    "All Languages": "Alle talen",
    "All Voice Controls": "Alle spraakbesturingen",
    "Uploader Email": "E-mail van uploader",
    "Channel Name": "Kanaalnaam",
    "Enter channel name (e.g., BBC, HBO)": "Voer de kanaalnaam in (bijv. BBC, HBO)",
    "Channel Name Upload": "Kanaalnaam uploaden",
    "Search Channels": "Zoek kanalen",
    "Search for a channel...": "Zoek een kanaal...",
    "Upload Channel Names": "Kanaalnamen uploaden",
    "Excel Upload": "Excel uploaden",
    "Manual Upload": "Manueel uploaden",
    "Upload Excel File": "Excel-bestand uploaden",
    "Download Template": "Sjabloon downloaden",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "Het Excel-bestand moet de kolommen 'languageCode' en 'channelName' bevatten.",
    "Upload Channels": "Kanalen uploaden",
    "My Channels": "Mijn kanalen",
    "All Channels": "Alle kanalen",
    "My Uploaded Channels": "Mijn geüploade kanalen",
    "Language Code": "Taalcode",
    "Actions": "Acties",
    "Channels by Language Code": "Kanalen per taalcode",
    "Channel Count": "Aantal kanalen",
    "Only .xlsx or .xls files are allowed.": "Alleen .xlsx- of .xls-bestanden zijn toegestaan.",
    "File size should be 5MB or less.": "De bestandsgrootte mag maximaal 5 MB zijn.",
    "Please select an Excel file to upload.": "Selecteer een Excel-bestand om te uploaden.",
    "Please provide a valid uploader email.": "Geef een geldig e-mailadres van de uploader op.",
    "Channels processed successfully!": "Kanalen succesvol verwerkt!",
    "Inserted Channels": "Ingevoegde kanalen",
    "Skipped Duplicates": "Overgeslagen duplicaten",
    "Skipped Channels": "Overgeslagen kanalen",
    "Invalid Rows": "Ongeldige rijen",
    "Language Codes": "Taalcodes",
    "Country": "Land",
    "Select or Enter Country": "Land selecteren of invoeren",
    "Select a country...": "Selecteer een land...",
    "Excel file should contain 'appId' and 'appName' columns.": "Het Excel-bestand moet de kolommen 'appId' en 'appName' bevatten.",
    "App ID": "App-ID",
    "Upload App Names.": "App-namen uploaden.",
    "Upload Apps": "Apps uploaden",
    "My Apps": "Mijn apps",
    "All Apps": "Alle apps",
    "App Name": "App-naam",
    "Edit": "Bewerken",
    "Delete": "Verwijderen",
    "Apps by App ID": "Apps per App-ID",
    "App Count": "Aantal apps",
    "Enter uploader email": "Voer het e-mail van de uploader in",
    "Enter app ID (alphanumeric and 14underscores only)": "Voer de App-ID in (alleen alfanumeriek en underscores)",
    "Enter app name": "Voer de app-naam in",
    "My Uploaded Apps": "Mijn geüploade apps",
  },
  'nl-NL': {
    "Voice Control": "Spraakbesturing",
    "Audio File Upload": "Audiobestand uploaden",
    "Logout": "Uitloggen",
    "Admin Page": "Beheerpagina",
    "Select Language": "Taal selecteren",
    "Select Gender": "Geslacht selecteren",
    "Select Age Category": "Leeftijdscategorie selecteren",
    "Category": "Categorie",
    "Voice Control": "Spraakbesturing",
    "Sample Utterances": "Voorbeeldzinnen",
    "Select Audio Input Method": "Audiobron selecteren",
    "Upload Audio": "Audio uploaden",
    "Record Audio": "Audio opnemen",
    "Start Audio": "Starten",
    "Upload": "Uploaden",
    "Previews Audio": "Audiovoorbeeld",
    "Uploaded Audios": "Geüploade audio's",
    "Language": "Taal",
    "Gender & Age": "Geslacht en leeftijd",
    "Audio Text": "Audiotekst",
    "AI Transcribed Text": "Door AI getranscribeerde tekst",
    "File Name": "Bestandsnaam",
    "Play": "Afspelen",
    "Stop": "Stoppen",
    "Download": "Downloaden",
    "OK": "OK",
    "Not OK": "Niet OK",
    "No utterances available": "Geen zinnen beschikbaar",
    "Transcribing": "Bezig met transcriberen",
    "Choose File": "Bestand kiezen",
    "No file chosen": "Geen bestand gekozen",
    "English (US)": "Engels (VS)",
    "Female": "Vrouw",
    "Male": "Man",
    "Kid": "Kind",
    "Adult": "Volwassene",
    "Older": "Ouder",
    "Select Category": "Categorie selecteren",
    "Select Voice Control": "Spraakbesturing selecteren",
    "Login": "Inloggen",
    "Email": "E-mail",
    "Password": "Wachtwoord",
    "Success": "Succes",
    "Successfully logged in!": "Succesvol ingelogd!",
    "Error": "Fout",
    "Login failed": "Inloggen mislukt",
    "Network error: ": "Netwerkfout: ",
    "Something went wrong": "Er ging iets mis",
    "Translated Text": "Vertaalde tekst",
    "Enter the correct text here": "Voer hier de juiste tekst in",
    "User Input": "Gebruikersinvoer",
    "User Input Text": "Gebruikersinvoertekst",
    "Transcription Status": "Transcriptiestatus",
    "Filter by Language": "Filteren op taal",
    "Filter by Voice Control": "Filteren op spraakbesturing",
    "Get ZIP": "ZIP downloaden",
    "Select All": "Alles selecteren",
    "Upload Date": "Upload datum",
    "All Languages": "Alle talen",
    "All Voice Controls": "Alle spraakbesturingen",
    "Uploader Email": "E-mail van uploader",
    "Channel Name": "Kanaalnaam",
    "Enter channel name (e.g., BBC, HBO)": "Voer de kanaalnaam in (bijv. BBC, HBO)",
    "Channel Name Upload": "Kanaalnaam uploaden",
    "Search Channels": "Zoek kanalen",
    "Search for a channel...": "Zoek een kanaal...",
    "Upload Channel Names": "Kanaalnamen uploaden",
    "Excel Upload": "Excel uploaden",
    "Manual Upload": "Handmatig uploaden",
    "Upload Excel File": "Excel-bestand uploaden",
    "Download Template": "Sjabloon downloaden",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "Het Excel-bestand moet de kolommen 'languageCode' en 'channelName' bevatten.",
    "Upload Channels": "Kanalen uploaden",
    "My Channels": "Mijn kanalen",
    "All Channels": "Alle kanalen",
    "My Uploaded Channels": "Mijn geüploade kanalen",
    "Language Code": "Taalcode",
    "Actions": "Acties",
    "Channels by Language Code": "Kanalen per taalcode",
    "Channel Count": "Aantal kanalen",
    "Only .xlsx or .xls files are allowed.": "Alleen .xlsx- of .xls-bestanden zijn toegestaan.",
    "File size should be 5MB or less.": "De bestandsgrootte mag maximaal 5 MB zijn.",
    "Please select an Excel file to upload.": "Selecteer een Excel-bestand om te uploaden.",
    "Please provide a valid uploader email.": "Geef een geldig e-mailadres van de uploader op.",
    "Channels processed successfully!": "Kanalen succesvol verwerkt!",
    "Inserted Channels": "Ingevoegde kanalen",
    "Skipped Duplicates": "Overgeslagen duplicaten",
    "Skipped Channels": "Overgeslagen kanalen",
    "Invalid Rows": "Ongeldige rijen",
    "Language Codes": "Taalcodes",
    "Country": "Land",
    "Select or Enter Country": "Land selecteren of invoeren",
    "Select a country...": "Selecteer een land...",
    "Excel file should contain 'appId' and 'appName' columns.": "Het Excel-bestand moet de kolommen 'appId' en 'appName' bevatten.",
    "App ID": "App-ID",
    "Upload App Names.": "App-namen uploaden.",
    "Upload Apps": "Apps uploaden",
    "My Apps": "Mijn apps",
    "All Apps": "Alle apps",
    "App Name": "App-naam",
    "Edit": "Bewerken",
    "Delete": "Verwijderen",
    "Apps by App ID": "Apps per App-ID",
    "App Count": "Aantal apps",
    "Enter uploader email": "Voer het e-mail van de uploader in",
    "Enter app ID (alphanumeric and 14underscores only)": "Voer de App-ID in (alleen alfanumeriek en underscores)",
    "Enter app name": "Voer de app-naam in",
    "My Uploaded Apps": "Mijn geüploade apps",
  },
'es-BR': {
    "Voice Control": "Controle de Voz",
    "Audio File Upload": "Carregar Arquivo de Áudio",
    "Logout": "Sair",
    "Admin Page": "Página de Administração",
    "Select Language": "Selecionar Idioma",
    "Select Gender": "Selecionar Gênero",
    "Select Age Category": "Selecionar Categoria de Idade",
    "Category": "Categoria",
    "Sample Utterances": "Exemplos de Frases",
    "Select Audio Input Method": "Selecionar Método de Entrada de Áudio",
    "Upload Audio": "Carregar Áudio",
    "Record Audio": "Gravar Áudio",
    "Start Audio": "Começar",
    "Upload": "Enviar",
    "Previews Audio": "Pré-visualizar Áudio",
    "Uploaded Audios": "Áudios Carregados",
    "Language": "Idioma",
    "Gender & Age": "Gênero e Idade",
    "Audio Text": "Texto do Áudio",
    "AI Transcribed Text": "Texto Transcrito por IA",
    "File Name": "Nome do Arquivo",
    "Play": "Tocar",
    "Stop": "Parar",
    "Download": "Baixar",
    "OK": "OK",
    "Not OK": "Não OK",
    "No utterances available": "Nenhuma frase disponível",
    "Transcribing": "Transcrevendo",
    "Choose File": "Escolher Arquivo",
    "No file chosen": "Nenhum arquivo escolhido",
    "English (US)": "Inglês (EUA)",
    "Female": "Feminino",
    "Male": "Masculino",
    "Kid": "Criança",
    "Adult": "Adulto",
    "Older": "Idoso",
    "Select Category": "Selecionar Categoria",
    "Select Voice Control": "Selecionar Controle por Voz",
    "Login": "Entrar",
    "Email": "E-mail",
    "Password": "Senha",
    "Success": "Sucesso",
    "Successfully logged in!": "Login realizado com sucesso!",
    "Error": "Erro",
    "Login failed": "Falha no login",
    "Network error: ": "Erro de rede: ",
    "Something went wrong": "Algo deu errado",
    "Translated Text": "Texto Traduzido",
    "Enter the correct text here": "Insira o texto correto aqui",
    "User Input": "Entrada do Usuário",
    "User Input Text": "Texto de Entrada do Usuário",
    "Transcription Status": "Estado da Transcrição",
    "Filter by Language": "Filtrar por Idioma",
    "Filter by Voice Control": "Filtrar por Controle de Voz",
    "Get ZIP": "Obter ZIP",
    "Select All": "Selecionar Tudo",
    "Upload Date": "Data de Carregamento",
    "All Languages": "Todos os Idiomas",
    "All Voice Controls": "Todos os Controles de Voz",
    "Uploader Email": "E-mail do Carregador",
    "Channel Name": "Nome do Canal",
    "Enter channel name (e.g., BBC, HBO)": "Insira o nome do canal (ex.: BBC, HBO)",
    "Channel Name Upload": "Carregamento de Nome de Canal",
    "Search Channels": "Pesquisar Canais",
    "Search for a channel...": "Pesquisar por um canal...",
    "Upload Channel Names": "Carregar Nomes de Canais",
    "Excel Upload": "Carregar Excel",
    "Manual Upload": "Carregamento Manual",
    "Upload Excel File": "Carregar Arquivo Excel",
    "Download Template": "Baixar Modelo",
    "Excel file should contain 'languageCode' and 'channelName' columns.": "O arquivo Excel deve conter as colunas 'languageCode' e 'channelName'.",
    "Upload Channels": "Carregar Canais",
    "My Channels": "Meus Canais",
    "All Channels": "Todos os Canais",
    "My Uploaded Channels": "Meus Canais Carregados",
    "Language Code": "Código de Idioma",
    "Actions": "Ações",
    "Channels by Language Code": "Canais por Código de Idioma",
    "Channel Count": "Contagem de Canais",
    "Only .xlsx or .xls files are allowed.": "Apenas arquivos .xlsx ou .xls são permitidos.",
    "File size should be 5MB or less.": "O tamanho do arquivo deve ser 5MB ou menos.",
    "Please select an Excel file to upload.": "Por favor, selecione um arquivo Excel para carregar.",
    "Please provide a valid uploader email.": "Por favor, forneça um e-mail de carregador válido.",
    "Channels processed successfully!": "Canais processados com sucesso!",
    "Inserted Channels": "Canais Inseridos",
    "Skipped Duplicates": "Canais Duplicados Ignorados",
    "Skipped Channels": "Canais Ignorados",
    "Invalid Rows": "Linhas Inválidas",
    "Language Codes": "Códigos de Idioma",
    "Country": "País",
    "Select or Enter Country": "Selecionar ou Inserir País",
    "Select a country...": "Selecionar um país...",
    "Excel file should contain 'appId' and 'appName' columns.": "El archivo Excel debe contener las columnas 'appId' y 'appName'.",
    "App ID": "ID de la app",
    "Upload App Names.": "Subir nombres de apps.",
    "Upload Apps": "Subir apps",
    "My Apps": "Mis apps",
    "All Apps": "Todas las apps",
    "App Name": "Nombre de la app",
    "Edit": "Editar",
    "Delete": "Eliminar",
    "Apps by App ID": "Apps por ID",
    "App Count": "Cantidad de apps",
    "Enter uploader email": "Ingrese el correo del remitente",
    "Enter app ID (alphanumeric and 14underscores only)": "Ingrese el ID de la app (alfanumérico y guiones bajos solamente)",
    "Enter app name": "Ingrese el nombre de la app",
    "My Uploaded Apps": "Minhas Aplicações Enviadas",
}
};

export default translations;